<script>
    import { mapMutations, mapState } from 'vuex';
    import ReusableMethods from '../mixins/reusable_methods';
    import VueButton from '~/components/button/components/button';

    export default {
        name: "session-forced-logout-dialog",

        components: {
            VueButton
        },

        mixins: [
            ReusableMethods
        ],

        props: {
            forcedExpirationTime: {
                type: Number,
                required: true
            },

            forcedTimeoutSeconds: {
                type: Number,
                required: true
            }
        },

        mounted() {
            this.triggerWarningEvents();
        },

        data() {
            return {
                sessionForcedExpirationTime: null
            }
        },

        computed: {
            ...mapState('sessionTimeout', [
                'dialogsVisible',
                'formattedLogoutTime',
            ]),

            forcedTimeoutHours() {
                return Math.round(this.forcedTimeoutSeconds / 3600);
            },

            remainingSeconds: {
                cache: false,
                get() {
                    return this.forcedExpirationTime - this.getCurrentTime();
                }
            },

            warningTimer: {
                cache: false,
                get() {
                    return (this.forcedExpirationTime - 600) - this.getCurrentTime();
                }
            }
        },

        methods: {
            ...mapMutations('sessionTimeout', [
                'updateDialogsVisible',
                'updateLogoutTimerVisible',
                'stopInactivityWarningTimer',
            ]),

            closeDialog() {
                this.updateDialogsVisible({ forcedDialog: false });
                this.updateLogoutTimerVisible(true);
            },

            triggerWarningEvents() {
                setTimeout(() => {
                    this.updateDialogsVisible({ inactivityDialog: false });
                    setInterval(this.intervalTick, 1000);
                    this.updateDialogsVisible({ forcedDialog: true });
                    this.stopInactivityWarningTimer(true);
                }, this.warningTimer * 1000)
            },

            intervalTick() {
                if (this.remainingSeconds <= 0) {
                    this.logout();
                }

                this.formatTime(this.remainingSeconds, 'forced');
            }
        },
    }
</script>

<template>
    <el-dialog
        title="Session Timeout"
        :close-on-click-modal="false"
        :show-close="true"
        :visible.sync="dialogsVisible.forcedDialog"
        size="tiny"
        @close="closeDialog">
        <p>
            Your organization requires you to login again after {{ forcedTimeoutHours }} continuous hours. Please save all your work and log in again.
            <br /><br />
            You will be automatically signed out in:
        </p>
        <h3 class="text-center">{{ formattedLogoutTime }}</h3>

        <div slot="footer">
            <vue-button
                type="white"
                size="sm"
                class="m-r-5"
                @click="closeDialog">
                Close
            </vue-button>

            <vue-button
                type="primary"
                size="sm"
                @click="userLogout">
                Sign Out
            </vue-button>
        </div>
    </el-dialog>
</template>